/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Exit: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="exit" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1224.5364444444444 680L961.9922222222222 417.4557777777777L908.563111111111 470.8811111111112L1079.908 642.2222222222222H453.3333333333334V717.7777777777777H1079.908L908.563111111111 889.1188888888889L961.9922222222222 942.548L1224.5364444444444 680zM717.7777777777778 1020H226.6666666666667L226.6666666666667 340H717.7777777777778V528.8888888888889H793.3333333333334V340C793.3333333333334 298.2706666666666 759.5071111111112 264.4444444444444 717.7777777777778 264.4444444444444H151.1111111111111L151.1111111111111 1020C151.1111111111111 1061.7282 184.9384666666667 1095.5555555555557 226.6666666666667 1095.5555555555557H717.7777777777778C759.5071111111112 1095.5555555555557 793.3333333333334 1061.7282 793.3333333333334 1020V831.1111111111111H717.7777777777778V1020z" : "M979.6291555555556 544L769.5937777777777 333.9646222222223L726.8504888888889 376.704888888889L863.9264 513.7777777777778H362.6666666666667V574.2222222222223H863.9264L726.8504888888889 711.2951111111112L769.5937777777777 754.0384L979.6291555555556 544zM574.2222222222222 816H181.3333333333333L181.3333333333333 272H574.2222222222222V423.1111111111111H634.6666666666666V272C634.6666666666666 238.6165333333334 607.605688888889 211.5555555555556 574.2222222222222 211.5555555555556H120.8888888888889L120.8888888888889 816C120.8888888888889 849.38256 147.9507733333333 876.4444444444445 181.3333333333333 876.4444444444445H574.2222222222222C607.605688888889 876.4444444444445 634.6666666666666 849.38256 634.6666666666666 816V664.8888888888889H574.2222222222222V816z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Exit.displayName = `Blueprint5.Icon.Exit`;
export default Exit;
